import clsx from 'clsx';
import { Select } from '@anyemp/ui-kit';

const SORT_ORDER_OPTIONS = [
  { value: 'ASC', label: 'Ascending' },
  { value: 'DESC', label: 'Descending' },
];

export const ResponsiveCardGrid = ({ children, className }) => (
  <div className={clsx('grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3', className)}>
    {children}
  </div>
);

export const RecordCard = ({ children, className, onClick, actionLabel = 'Open record' }) => {
  return (
    <article
      className={clsx(
        'flex h-full min-w-0 flex-col rounded-xl border border-light-border-primary bg-light-bg-primary p-4 text-left shadow-sm dark:border-dark-border-primary dark:bg-dark-bg-secondary',
        onClick && 'transition-colors hover:border-primary-400',
        className
      )}
    >
      {children}
      {onClick && (
        <div className="mt-auto pt-4">
          <div className="flex justify-end border-t border-light-border-primary pt-3 dark:border-dark-border-primary">
            <button
              type="button"
              onClick={onClick}
              className="min-h-11 rounded-lg px-3 text-sm font-medium text-primary-600 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:text-primary-400 dark:hover:bg-primary-900/20"
            >
              {actionLabel}
            </button>
          </div>
        </div>
      )}
    </article>
  );
};

export const RecordCardHeader = ({ title, subtitle, badge, actions, className }) => (
  <div className={clsx('flex min-w-0 items-start justify-between gap-3', className)}>
    <div className="min-w-0 flex-1">
      <div className="flex min-w-0 flex-wrap items-center gap-2">
        <div className="min-w-0 break-words font-semibold text-light-text-primary dark:text-dark-text-primary">
          {title}
        </div>
        {badge}
      </div>
      {subtitle && <div className="mt-1 break-words text-sm text-light-text-tertiary dark:text-dark-text-tertiary">{subtitle}</div>}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center justify-end gap-1">{actions}</div>}
  </div>
);

export const RecordCardFields = ({ children, className }) => (
  <dl className={clsx('mt-4 grid min-w-0 grid-cols-1 gap-3 text-sm sm:grid-cols-2', className)}>
    {children}
  </dl>
);

export const RecordCardField = ({ label, children, className }) => (
  <div className={clsx('min-w-0', className)}>
    <dt className="text-xs font-medium uppercase tracking-wide text-light-text-tertiary dark:text-dark-text-tertiary">{label}</dt>
    <dd className="mt-1 min-w-0 break-words text-light-text-secondary dark:text-dark-text-secondary">{children ?? '—'}</dd>
  </div>
);

export const CardSortControls = ({ options, sortBy, sortOrder, onSortByChange, onSortOrderChange, className }) => (
  <div className={clsx('grid min-w-0 flex-1 grid-cols-1 gap-2 sm:max-w-xl sm:grid-cols-2', className)}>
    <Select
      label="Sort by"
      options={options}
      value={sortBy}
      onChange={(value) => onSortByChange(value || '')}
      size="small"
      fullWidth
    />
    <Select
      label="Order"
      options={SORT_ORDER_OPTIONS}
      value={sortOrder || 'ASC'}
      onChange={(value) => onSortOrderChange(value || 'ASC')}
      disabled={!sortBy}
      size="small"
      fullWidth
    />
  </div>
);
